// extracted by mini-css-extract-plugin
module.exports = {"card":"NewsCard-module--card--3hFw3","content":"NewsCard-module--content--2vsku","title":"NewsCard-module--title--3MZdO","img":"NewsCard-module--img--3sIg5"};